import { render, staticRenderFns } from "./basicView.vue?vue&type=template&id=3f525126"
import script from "./basicView.vue?vue&type=script&lang=js"
export * from "./basicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports